import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=037d583e&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=js"
export * from "./activityList.vue?vue&type=script&lang=js"
import style0 from "./activityList.vue?vue&type=style&index=0&id=037d583e&prod&lang=css"
import style1 from "./activityList.vue?vue&type=style&index=1&id=037d583e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d583e",
  null
  
)

export default component.exports